import { Box, Typography } from '@material-ui/core';
import { DetailsIcon } from '@vyce/core/src/components/DetailsIcon';
import { FormattedDescription } from '@vyce/core/src/components/FormattedDescription';
import { PDFPreview } from '@vyce/core/src/components/PreviewDocumentDialog/components/PDFPreview';
import { safeHref } from '@vyce/core/src/utils/url';
import ReactPlayer from 'react-player';

interface Props {
  title: string;
  totalAnswers?: number;
  description?: string;
  videoLink?: string;
  photoUrl?: string;
  pdfUrl?: string;
  explanation?: string;
}

export const FormSummaryQuestionTitle: React.FC<Props> = ({
  title,
  totalAnswers,
  description,
  videoLink,
  photoUrl,
  explanation,
  pdfUrl,
}) => {
  return (
    <Box>
      <Box display="flex" alignItems="center" justifyContent="space-between">
        <Typography variant="body1">{title}</Typography>

        {explanation && (
          <Box className="no-print">
            <DetailsIcon content={<FormattedDescription text={explanation} variant="body2" />} />
          </Box>
        )}
      </Box>
      {explanation && (
        <Box className="form-summary-print-only" style={{ marginTop: 8 }}>
          <FormattedDescription text={explanation} variant="body2" />
        </Box>
      )}
      {!!totalAnswers && (
        <Typography variant="body2" color="textSecondary">
          {totalAnswers} answers
        </Typography>
      )}
      {!!description && (
        <Box style={{ marginTop: 16 }}>
          <FormattedDescription text={description} variant="body2" />
        </Box>
      )}
      {!!videoLink && (
        <>
          <Box className="form-summary-screen-only" style={{ marginTop: 16 }}>
            <ReactPlayer width="100%" height={400} controls url={videoLink} />
          </Box>
          <Box className="form-summary-print-only" style={{ marginTop: 16 }}>
            <Typography variant="body2" color="textSecondary">
              Video:{' '}
              <a
                href={safeHref(videoLink)}
                target="_blank"
                rel="noopener noreferrer"
                className="form-summary-print-link"
              >
                {videoLink}
              </a>
            </Typography>
          </Box>
        </>
      )}
      {!!photoUrl && (
        <img
          src={photoUrl}
          alt={title}
          style={{ marginTop: 16, width: '100%', height: 300, objectFit: 'contain' }}
        />
      )}
      {!!pdfUrl && (
        <>
          <Box className="form-summary-screen-only" style={{ marginTop: 16 }}>
            <PDFPreview url={pdfUrl} />
          </Box>
          <Box className="form-summary-print-only" style={{ marginTop: 16 }}>
            <Typography variant="body2" color="textSecondary">
              PDF attachment:{' '}
              <a href={safeHref(pdfUrl)} target="_blank" rel="noopener noreferrer" className="form-summary-print-link">
                {pdfUrl}
              </a>
            </Typography>
          </Box>
        </>
      )}
    </Box>
  );
};
